var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GenericForm',_vm._b({on:{"updated":_vm.onUpdate,"validated":function($event){_vm.isValid = $event}}},'GenericForm',_vm.genericFormConfig,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }